
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'office-ui-fabric-react/lib/Link';

import infoGetActions from '../../../sagas/info';
import { getToken } from '../../../reducers/auth';
import { getProjectKatuzeItems } from '../../../reducers/project';
import { getOpsubName } from '../../../reducers/opsub';

const LinkToOpsub = ({isknDate, opsub}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const opsubName = useSelector(state => getOpsubName(opsub));

    const handleClick = () => {
        infoActions.getObjectOpsub(
            token,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            opsub.opsub_id
        );
    }

    return (
        <Link onClick={handleClick} title="Zobrazit informace o vlastníkovi">{opsubName}</Link>
    )
}

export default LinkToOpsub;
